import React, { forwardRef } from "react";
import PropTypes from "prop-types";
import { useDroppable } from "@dnd-kit/core";
import colors from "app/theme/base/colors";
import { alpha } from "@mui/material/styles";

// 🔥 Hacemos que este slot reciba y exponga el ref real para anclar el modal
const DroppableSlot = forwardRef(function DroppableSlot({ id, day, index, children }, externalRef) {
  const { setNodeRef, isOver } = useDroppable({
    id,
    data: { type: "slot", slotId: id, day, index },
  });

  // 🔥 Combinar el ref de dnd-kit con el ref externo
  const combinedRef = (element) => {
    setNodeRef(element); // ref interno para drag & drop
    if (typeof externalRef === "function") {
      externalRef(element);
    } else if (externalRef && typeof externalRef === "object") {
      externalRef.current = element; // ref externo para el Popover
    }
  };

  return (
    <div
      ref={combinedRef}
      data-isover={isOver}
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
        borderRadius: "8px",
        backgroundColor: isOver ? alpha(colors.primary.main, 0.12) : "transparent",
        outline: isOver ? `2px solid ${colors.primary.main}` : "none",
        outlineOffset: isOver ? "-2px" : 0,
        transition: "background-color 0.15s ease, outline-color 0.15s ease",
      }}
    >
      {children}
    </div>
  );
});

DroppableSlot.propTypes = {
  id: PropTypes.string.isRequired,
  day: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  children: PropTypes.element.isRequired,
};

export default DroppableSlot;
